const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '像刷短视频一样看漫画，无需翻页，沉浸式连续阅读体验，让追漫更加畅快淋漓。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量漫画大全',
    desc: '收录12,000+部各类漫画作品，从经典神作到热门新番，免费漫画大全任你畅读。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '每日同步更新',
    desc: '热门连载第一时间更新，追更不落空。紧跟日本连载进度，中文汉化快人一步。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '手机、平板、电脑完美适配，阅读进度云端同步，随时随地无缝切换设备追漫。',
  },
  {
    icon: 'ri-advertisement-line',
    title: '纯净阅读环境',
    desc: '无弹窗广告、无强制跳转，专注阅读本身。清爽界面设计，让漫画成为唯一主角。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          平台优势
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">为什么500万+漫友选择妖精动漫网</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-xl p-6 text-center cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-200">
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-50 flex items-center justify-center transition-colors duration-300 group-hover:bg-primary-100">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-sm text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}